import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Attendance")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Phase", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_18 = { class: "row mt-2" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Batch", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Term", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "col-md-2 mt-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_27 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batch_detail",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Training Calendar (Select the training day to enter the attendance data) ")
], -1)
const _hoisted_29 = { class: "row w-100 mb-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_31 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_35 = {
  id: "batch_detail",
  class: "collapse show"
}
const _hoisted_36 = { class: "collapse show" }
const _hoisted_37 = { class: "card-body border-top p-5" }
const _hoisted_38 = { class: "pt-0" }
const _hoisted_39 = { class: "row g-6 g-xl-6 mb-6 mb-xl-9" }
const _hoisted_40 = {
  key: 0,
  class: "card h-70"
}
const _hoisted_41 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_42 = {
  class: "text-gray-800 text-primary flex-column",
  style: {"min-height":"245px"}
}
const _hoisted_43 = { class: "fs-5 fw-bolder mb-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_50 = ["onClick", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_AttendanceUpdateDrwaer = _resolveComponent("AttendanceUpdateDrwaer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    name: "tranche_id",
                    placeholder: "Select Phase",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: tranche.id,
                          label: tranche.label,
                          value: tranche.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tranche.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Training Partner",
                    name: "entity_id",
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.getTrainingInstitute
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                      '[' + info.entity_short_name + '] - ' + info.entity_name
                    ,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    name: "institute_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.courseInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.institute_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Course",
                    modelValue: _ctx.batch.course_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                    name: "course_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchInfo()))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.course_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.course_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Batch",
                    modelValue: _ctx.batch.batch_id,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.batch.batch_id) = $event)),
                    name: "batch_id",
                    filterable: "",
                    style: {"width":"100%"},
                    onChange: _ctx.termInfo
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.batch_sequence_number,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.batch_sequence_number), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _hoisted_24,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Term",
                    modelValue: _ctx.batch.term_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.batch.term_id) = $event)),
                    name: "batch_id",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.termList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.term_no,
                          label: info.term_no,
                          value: info.term_no
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.term_no), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.calenderDetails())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_26
                  ])
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    (_ctx.showcalendarDetails)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "card mb-5 mb-xl-10",
          key: _ctx.componentKey
        }, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                  title: "Print",
                  "data-v-54b12dc8": "",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPdf()))
                }, _hoisted_33),
                _hoisted_34
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainingCalendar, (data, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-12 col-sm-12 col-xl-2"
                      }, [
                        (data?.class_type != 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createTextVNode(_toDisplayString(_ctx.moment(data?.training_date).format('DD-MM-YYYY')) + " ", 1),
                                    _hoisted_44,
                                    _createTextVNode(" " + _toDisplayString(data?.training_calendar_details?.attendance_date
                            ? '(' +
                              _ctx.moment(
                                data?.training_calendar_details?.attendance_date
                              ).format('DD-MM-YYYY') +
                              ')'
                            : '(No data found)') + " ", 1),
                                    _hoisted_45,
                                    _createTextVNode(" " + _toDisplayString(data.details ? '  P:' + data?.details?.present : '') + _toDisplayString(data.details ? ' L:' + data?.details?.late : '') + _toDisplayString(data.details ? ' A:' + data?.details?.absent : '') + " " + _toDisplayString(data?.training_calendar_details?.lead_trainer_info
                            ? ' LT:' +
                              data?.training_calendar_details?.lead_trainer_info
                                ?.employee_info?.name
                            : 'LT:') + " ", 1),
                                    _hoisted_46,
                                    _createTextVNode(" " + _toDisplayString(data?.training_calendar_details
                            ?.associate_trainer_info
                            ? ' AT:' +
                              data?.training_calendar_details
                                ?.associate_trainer_info?.employee_info?.name
                            : 'AT:') + " ", 1),
                                    _hoisted_47,
                                    _createTextVNode(" " + _toDisplayString(data?.training_calendar_details?.guest_trainer_info
                            ? ' GT:' +
                              data?.training_calendar_details
                                ?.guest_trainer_info?.employee_info?.name
                            : 'GT:') + " ", 1),
                                    _hoisted_48,
                                    _createTextVNode(" " + _toDisplayString(data?.training_calendar_details?.updated_at
                            ? ' UT: (' +
                              _ctx.moment(
                                data?.training_calendar_details?.updated_at
                              ).format('DD-MM-YYYY hh:mm:ss A') +
                              ')'
                            : 'UT:') + " ", 1),
                                    _hoisted_49
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    "data-kt-drawer-toggle": "true",
                                    "data-kt-drawer-target": "#kt_drawer_attendance_details",
                                    onClick: ($event: any) => (_ctx.edit(data)),
                                    id: 
                          this.opendrawer == true
                            ? 'kt_drawer_attendance_details_button'
                            : ''
                        ,
                                    class: _normalizeClass([[
                          data?.is_attendance_given
                            ? _ctx.secondaryClass
                            : _ctx.dangerClass,
                        ], "btn btn-icon btn-sm me-1"])
                                  }, _toDisplayString(index + 1), 11, _hoisted_50)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_AttendanceUpdateDrwaer)
  ], 64))
}